import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Button 
        startIcon={<ArrowBackIcon />} 
        onClick={() => navigate('/')}
        sx={{ mb: 3 }}
      >
        Back to Home
      </Button>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: March 20, 2024
        </Typography>

        <Box sx={{ '& > *': { mb: 3 } }}>
          <Typography variant="body1" paragraph>
            This Privacy Policy describes how Richard Otieno for Teachers Union ("we," "us," or "our") collects, uses, and discloses your personal information when you visit our website or interact with our campaign.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect information that you provide directly to us, including:
          </Typography>
          <ul>
            <li>Name and contact information</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Location information</li>
            <li>Any other information you choose to provide</li>
          </ul>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use the information we collect to:
          </Typography>
          <ul>
            <li>Send you campaign updates and newsletters</li>
            <li>Respond to your inquiries and requests</li>
            <li>Organize campaign events and activities</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            3. Data Protection
          </Typography>
          <Typography variant="body1" paragraph>
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your data is stored securely and accessed only by authorized personnel.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            4. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            Under the Data Protection Act, 2019, you have the right to:
          </Typography>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Object to processing of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            5. Cookies and Tracking
          </Typography>
          <Typography variant="body1" paragraph>
            We use cookies and similar tracking technologies to improve your browsing experience. You can control cookie settings through your browser preferences.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            6. Third-Party Services
          </Typography>
          <Typography variant="body1" paragraph>
            We may use third-party services that collect, monitor, and analyze website usage. These services have their own privacy policies and may collect information sent by your device.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            7. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            8. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, please contact us at:
          </Typography>
          <Typography variant="body1">
            Email: privacy@richardotieno.com<br />
            Phone: +254 XXX XXX XXX<br />
            Address: Nairobi, Kenya
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default PrivacyPolicy; 